let firstScreenRequests = [];
let firstScreenRequestsResolved = false;
export function getJsbFirstScreenRequests() {
    firstScreenRequestsResolved = true;
    return firstScreenRequests;
}
export function startJsbMonitor(jsbClients, slardarClient) {
    for (const jsbClient of jsbClients) {
        try {
            monitorJsb(jsbClient, slardarClient);
        }
        catch {
            // do nothing
        }
    }
}
export function resetStateForTesting() {
    firstScreenRequests = [];
    firstScreenRequestsResolved = false;
}
function monitorJsb(jsbClient, slardarClient) {
    const requestMap = {};
    jsbClient.globalConfig({
        onInvokeStart: (config) => {
            if (!config) {
                return config;
            }
            const { method, params } = config;
            if (method === 'sendLogV3') {
                return config;
            }
            const now = Date.now();
            config.ttap_id = `method_${now}_${Math.floor(Math.random() * 1000)}`;
            if (method === 'fetch' || method === 'request') {
                requestMap[config.ttap_id] = {
                    request: {
                        method: params.method,
                        url: params.url,
                        timestamp: now,
                    },
                    startTimestamp: now,
                };
            }
            else {
                requestMap[config.ttap_id] = {
                    request: undefined,
                    startTimestamp: now,
                };
            }
            return config;
        },
        onInvokeEnd: (invokeResponse) => {
            var _a, _b, _c, _d;
            if (!invokeResponse) {
                return;
            }
            const { response: res, config } = invokeResponse;
            if (!config) {
                return;
            }
            const { method, ttap_id } = config;
            if (method === 'sendLogV3' || !ttap_id || !requestMap[ttap_id]) {
                return;
            }
            const now = Date.now();
            const navStart = Math.round(now - performance.now());
            const { request } = requestMap[ttap_id];
            if ((method === 'fetch' || method === 'request') && request) {
                const startTime = request.timestamp - navStart;
                const endTime = now - navStart;
                const duration = endTime - startTime;
                const response = {
                    is_custom_error: false,
                    status: (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.httpCode) !== null && _b !== void 0 ? _b : 200,
                    timestamp: now,
                    timing: {
                        name: request.url,
                        startTime,
                        requestStart: startTime,
                        responseStart: endTime,
                        responseEnd: endTime,
                        duration,
                    },
                };
                const { ignoreApiUrl = [], includeApiUrl = [] } = (_d = (_c = slardarClient === null || slardarClient === void 0 ? void 0 : slardarClient.getState) === null || _c === void 0 ? void 0 : _c.call(slardarClient)) !== null && _d !== void 0 ? _d : {};
                if (!ignoreApiUrl.length) {
                    slardarClient.callClient('report', {
                        ev_type: 'http',
                        payload: {
                            api: 'jsbridge',
                            request,
                            response,
                            duration,
                        },
                    });
                }
                else {
                    const needIgnore = ignoreApiUrl.some((url) => typeof url === 'string' ? request.url.includes(url) : url.test(request.url));
                    if (!needIgnore) {
                        slardarClient.callClient('report', {
                            ev_type: 'http',
                            payload: {
                                api: 'jsbridge',
                                request,
                                response,
                                duration,
                            },
                        });
                    }
                }
                if (!firstScreenRequestsResolved) {
                    if (!ignoreApiUrl.length && !includeApiUrl.length) {
                        firstScreenRequests.push({ startTime: request.timestamp, endTime: now });
                    }
                    else if (includeApiUrl.length) {
                        const included = includeApiUrl.some((url) => typeof url === 'string' ? request.url.includes(url) : url.test(request.url));
                        if (included) {
                            firstScreenRequests.push({ startTime: request.timestamp, endTime: now });
                        }
                    }
                    else {
                        const needIgnore = ignoreApiUrl.some((url) => typeof url === 'string' ? request.url.includes(url) : url.test(request.url));
                        if (!needIgnore) {
                            firstScreenRequests.push({ startTime: request.timestamp, endTime: now });
                        }
                    }
                }
            }
            else {
                slardarClient.callClient('sendEvent', {
                    name: 'jsb_event',
                    metrics: {
                        duration: now - requestMap[ttap_id].startTimestamp,
                        requestStart: requestMap[ttap_id].startTimestamp - navStart,
                        responseEnd: now - navStart,
                    },
                    categories: {
                        jsb_method: method,
                    },
                });
            }
            delete requestMap[ttap_id];
        },
    });
}
//# sourceMappingURL=jsb.js.map